export default __webpack_public_path__ + "static/media/30dc.aba5e495.svg";